export default __webpack_public_path__ + "static/media/Feature4.76b047f4.svg";